module.exports = __webpack_public_path__ + "static/clearing-111eb61dfd66d704de2ccd67917e0d33.jpg";